import axios from 'axios'

export default class ApiManagerActivity {
    /**
     * Get prestations (activites) fast list
     */
    static async fetchPrestations(params) {
        return axios.get(`/back-office/list/fast/prestations?` + params).then((res) => res.data)
    }

    /**
     * Change prestations (activites) ordering
     */
    static async changeOrder(payload) {
        return axios.post('/back-office/prestations/change/order', payload).then((res) => res.data)
    }
}
